import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { ElectricityChangesPage, ElectricityChangesPageProps } from "./ElectricityChangesPage";

export const EMPTY_PAGE_CONTENT: ElectricityChangesPageProps = {
  pageTitle: "",
};

export const CANONICAL_LINK = "/personal/electricity/connection-changes";

export const ElectricityChangesPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<ElectricityChangesPageProps>("changes_to_electricity_connections", EMPTY_PAGE_CONTENT);
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <ElectricityChangesPage {...routeProps} {...content} />;
};
